var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGradientLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 541.2 197.5",
    style: {
      enableBackground: "new 0 0 541.2 197.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#Path_3_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path_3_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.684,
    y1: 168.2713,
    x2: 171.684,
    y2: 168.2713,
    gradientTransform: "matrix(541.177 0 0 -135.578 -92370.2656 22881.5918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6C94F7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF3162"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    className: "st0",
    d: "M81.4,85.4c0,7.5-6.1,13.6-13.6,13.6c-7.5,0-13.6-6.1-13.6-13.6c0-7.5,6.1-13.6,13.6-13.6 c0,0,0,0,0,0C75.3,71.9,81.4,77.9,81.4,85.4C81.4,85.4,81.4,85.4,81.4,85.4z M473.4,108.4c-7.5,0-13.5,6.1-13.5,13.6 c0,7.5,6.1,13.5,13.6,13.5c7.5,0,13.5-6.1,13.5-13.6C486.9,114.4,480.8,108.4,473.4,108.4L473.4,108.4z M274.1,99 c6.2,0,11.3-5.1,11.3-11.3V67.7c0-25,20.3-45.2,45.2-45.2c25,0,45.2,20.2,45.2,45.2v56.4c0,6.2,5.1,11.3,11.3,11.3 s11.3-5.1,11.3-11.3V67.7C398.4,30.3,368-0.1,330.5,0c-22.7,0-43.8,11.4-56.4,30.3C253.4-0.9,211.3-9.4,180,11.4 c-18.9,12.6-30.2,33.7-30.3,56.4v56.4c0,6.2,5.1,11.3,11.3,11.3s11.3-5.1,11.3-11.3V67.7c0-25,20.3-45.2,45.2-45.2 c25,0,45.2,20.2,45.2,45.2v19.9C262.8,93.9,267.9,99,274.1,99L274.1,99z M416.8,0c-6.2,0-11.3,5.1-11.3,11.3v19.9 c0.1,37.5,30.6,67.7,68.1,67.6c37.3-0.1,67.4-30.3,67.6-67.6V11.3c0-6.2-5.1-11.3-11.3-11.3s-11.3,5.1-11.3,11.3v19.9 c0,25-20.3,45.2-45.2,45.2c-25,0-45.2-20.2-45.2-45.2V11.3C428.1,5.1,423.1,0,416.8,0L416.8,0z M135.7,124.2V67.7 c0-37.5-30.4-67.8-67.8-67.8S0,30.3,0,67.7v56.4c0,6.2,5.1,11.3,11.3,11.3c6.2,0,11.3-5.1,11.3-11.3V67.7c0-25,20.2-45.2,45.2-45.2 c25,0,45.2,20.2,45.2,45.2v56.4c0,6.2,5.1,11.3,11.3,11.3S135.7,130.4,135.7,124.2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientLogo);
export default __webpack_public_path__ + "static/media/gradientLogo.c76c2a3f3d8c82938b46d1ded312ade9.svg";
export { ForwardRef as ReactComponent };